import { setUsrAppRefreshParams } from '@jfs/network'
import { Box, Icon, Spacer, Text } from '@jfs/ui-new'
import { DrawerContentComponentProps, DrawerContentOptions, createDrawerNavigator } from '@react-navigation/drawer'
import { ParamListBase, useNavigation } from '@react-navigation/native'
import { StackScreenProps } from '@react-navigation/stack'
import * as React from 'react'
import { FC, Suspense, useEffect, useLayoutEffect } from 'react'
import { Dimensions, ScaledSize } from 'react-native'
import LinearGradient from 'react-native-linear-gradient'
import { ExpandList } from '../../components/ExpandList'
import { FallbackScreen } from '../../components/FallbackScreen'
import { Footer } from '../../components/Footer'
import { getSubRights, menuItems } from '../../data'
import { useLazyApiData, useStores } from '../../data/store'
import { AppHeaderTransformer, extendAppSession } from '../../network/ExtendAppSession'
import { HeaderTransformer, extendUserSession } from '../../network/ExtendUserSession'
import { ScreenDetails } from '../../utils'
import { SessionExpire } from '../SessionExpire'
import { Header } from './header'
import styles from './styles'

const { PUBLIC_URL = '' } = window?._env_

export const getMenuItems = () => {
  return menuItems
    .map((item: any) => {
      const paths: any = {
        merchantDetails: '/merchantmapping',
        editEntity: '/entitymaster',
        editBankingCode: '/bankingcodes',
        userDetails: '/users',
        addusers: '/users',
        entityManagement: '/entityManagement',
        ledgerDetails: '/ledgermapping',
        holdtransaction: '/riskconfig',
        processingentitydetails: '/processingentity',
        finHubReports: '/finHubReports',
        'fAndRAction/riskHold': '/fAndRAction',
        'fAndRAction/riskHoldable': '/fAndRAction',
        'fAndRAction/limitHold': '/fAndRAction',
        'fAndRAudit/riskHoldAudit': '/fAndRAudit',
        'fAndRAudit/limitHoldAudit': '/fAndRAudit',
        'fAndRAudit/riskHoldableAudit': '/fAndRAudit',
      }
      const getPath = () => {
        let pathName = window?.location?.pathname.slice(PUBLIC_URL.length + 1)
        return paths[pathName] ?? `/${pathName}`
      }
      const expanded = item?.subRights?.filter((subRight: any) => subRight.path === getPath())?.length > 0 ?? false
      return {
        title: item?.name,
        icon: item?.icon ?? 'BANK',
        path: item?.path,
        isExpand: expanded,
        data: getSubRights(item?.subRights),
      }
    })
    .filter((item) => item?.data?.length > 0)
}

const useIsLargeScreen = () => {
  const [dimensions, setDimensions] = React.useState(Dimensions.get('window'))

  React.useEffect(() => {
    const onDimensionsChange = ({ window }: { window: ScaledSize }) => {
      setDimensions(window)
    }

    Dimensions.addEventListener('change', onDimensionsChange)

    return () => Dimensions.removeEventListener('change', onDimensionsChange)
  }, [])

  return dimensions.width > 550
}

interface CustomDrawerProps extends DrawerContentComponentProps<DrawerContentOptions> {
  updateSelectedSection: any
  reset: any
}
const CustomDrawerContent = ({ updateSelectedSection, reset, ...restprops }: CustomDrawerProps) => {
  const { forceSideMenuRefresh, setSideMenuRefresh } = useStores((store) => ({
    forceSideMenuRefresh: store.forceSideMenuRefresh,
    setSideMenuRefresh: store.setSideMenuRefresh,
  }))
  const [sectionData, setSectionData] = React.useState([])

  const handleOnPress = () => {
    // props.navigation.navigate('home')
  }

  const handleItemPress = (item: any) => {
    reset()
    restprops.navigation.reset({
      index: 0,
      routes: [{ name: item.name }],
    })
  }

  const handleSectionPress = (section: any) =>
    section?.data?.length === 0 ? props.navigation.navigate(section?.path) : {}

  const navigateToHome = () => restprops.navigation.navigate('home')

  useEffect(() => {
    if (!window.location.pathname.includes('/searchEntity')) {
      setSectionData(getMenuItems())
      setSideMenuRefresh(false)
    }
  }, [window.location.pathname, forceSideMenuRefresh])

  return (
    <LinearGradient
      colors={['#214796', '#1F71A2']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 0 }}
      style={{ flex: 1, height: '100%' }}>
      <Box {...styles.menuView}>
        <Box flexDirection="row" alignItems="center" ph={16} pv={12} underlayColor="PRIMARY" onPress={handleOnPress}>
          <Icon id={'JIO_ICON'} color={'WHITE'} size={34} />
          <Box justify={'center'} f={1} onPress={navigateToHome}>
            <Text
              color="WHITE"
              fontSize={20}
              numberOfLines={1}
              textAlign={'left'}
              lineHeight={24}
              fontFamily={'jiotype-medium'}
              fontWeight={'600'}>
              {'Pay Services'}
            </Text>
          </Box>
        </Box>
        <Box marginHorizontal={16} bg={'WHITE_SEPERATOR'} h={1} />
        <Spacer direction="vertical" size={36} />
        <Box ph={16}>
          <Text
            title={'OPTIONS'}
            color={'WHITE'}
            opacity={0.75}
            fontSize={13}
            letterSpacing={1}
            fontFamily={'jiotype-bold'}
          />
        </Box>
        <Box f={1}>
          <ExpandList data={sectionData} onItemPress={handleItemPress} onSectionPress={updateSelectedSection} />
        </Box>
      </Box>
    </LinearGradient>
  )
}

const CustomComponent: FC = (props: any) => {
  const {
    route: { name },
  } = props

  const { username, updateAllSessionData, usrAccessToken, usrRefreshToken, appAccessToken, appRefreshToken } =
    useStores((root) => ({
      updateAllSessionData: root.session.updateAllSessionData,
      usrAccessToken: root?.session?.usrAccessToken,
      usrRefreshToken: root?.session?.usrRefreshToken,
      appAccessToken: root?.session?.appAccessToken,
      appRefreshToken: root?.session?.appRefreshToken,
      username: root.user.name,
    }))

  useEffect(() => {
    setUsrAppRefreshParams(
      () => extendUserSession(username, usrAccessToken, usrRefreshToken),
      HeaderTransformer,
      () => extendAppSession(appAccessToken, appRefreshToken),
      AppHeaderTransformer,
    )
  }, [appAccessToken, appRefreshToken, username, usrAccessToken, usrRefreshToken])
  const navigation = useNavigation()

  const isSessionValid = (data: any) => {
    return (
      !!data?.appAccessToken &&
      !!data.appRefreshToken &&
      !!data.appIdToken &&
      !!data.usrAccessToken &&
      !!data.usrRefreshToken &&
      !!data.usrIdentifierToken
    )
  }
  const getFromLocal = () => {
    try {
      const sData = localStorage.getItem('sessionData')
      const sObj = JSON.parse(sData!)

      if (sData !== null && sData.length > 0 && isSessionValid(sObj)) {
        updateAllSessionData(sObj)
      } else {
        navigation.reset({
          index: 0,
          routes: [{ name: 'login' }],
        })
      }
    } catch (e) {
      navigation.reset({
        index: 0,
        routes: [{ name: 'login' }],
      })
    }
  }

  useEffect(() => {
    getFromLocal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appAccessToken])

  const details = ScreenDetails(name)

  const { comp: Component, props: additionalProps = {} } = details
  const isLargeScreen = useIsLargeScreen()
  return (
    <Box {...styles.menuContentView(isLargeScreen)}>
      <Header onGoBack={() => props.navigation.toggleDrawer()} isLargeScreen={isLargeScreen} />
      <Box {...styles.compContainer}>
        <Suspense fallback={<FallbackScreen />}>
          <Component {...props} {...additionalProps} />
        </Suspense>
      </Box>
      <Footer />
    </Box>
  )
}

const Drawer = createDrawerNavigator()
type Props = Partial<React.ComponentProps<typeof Drawer.Navigator>> & StackScreenProps<ParamListBase>

const DrawerScreen = ({ navigation, ...rest }: Props) => {
  useLayoutEffect(() => {
    navigation.setOptions({
      gestureEnabled: false,
    })
  }, [navigation])

  const {
    updateSelectedSection,
    getUserDetails,
    isValidSession,
    resetPagination,
    resetSelectedDate,
    resetGlobalSearchString,
  } = useStores((root) => ({
    updateSelectedSection: root.userManagement.updateSelectedSection,
    getUserDetails: root.user.fetchUserDetails,
    isValidSession: root.session.isValidSession,
    accessConfig: root.user.accessConfig,
    resetPagination: root?.resetPagination,
    resetSelectedDate: root?.resetSelectedDate,
    resetGlobalSearchString: root?.resetGlobalSearchString,
  }))
  const [getUserDetailsApi, { state: getUserDetailsApiState }] = useLazyApiData(getUserDetails)

  const isLargeScreen = useIsLargeScreen()

  const id = localStorage.getItem('params')

  useEffect(() => {
    const isFromLogin = rest?.route?.params?.isFromLogin
    if (isValidSession() && !isFromLogin) {
      getUserDetailsApi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getUserDetailsApi, isValidSession()])

  // useEffect(() => {
  //   if (getUserDetailsApiState === 'rejected') {
  //     const isCitrixIp = localStorage.getItem('isCitrixIp')
  //     localStorage.clear()
  //     localStorage.setItem('isCitrixIp', isCitrixIp)
  //     navigation.reset({
  //       index: 0,
  //       routes: [{ name: 'login' }],
  //     })
  //   }
  // }, [getUserDetailsApiState, navigation])

  const resetDatePagination = () => {
    resetSelectedDate()
    resetPagination()
    resetGlobalSearchString()
  }
  let pathName = window?.location?.pathname?.slice(1)
  if (!!pathName && pathName.includes('/')) {
    const index = pathName.indexOf('/')
    pathName = pathName.substring(index + 1)
  }
  return (
    <Box {...styles.container}>
      <SessionExpire />
      <Drawer.Navigator
        initialRouteName={rest?.route?.params?.isForceRefresh ? 'home' : pathName || 'home'}
        defaultStatus={isLargeScreen ? 'open' : 'closed'}
        screenOptions={{
          drawerPosition: 'left',
          drawerType: isLargeScreen ? 'permanent' : 'back',
          drawerStyle: isLargeScreen
            ? { borderRightWidth: 0, borderLeftWidth: 0, backgroundColor: '#214796', width: 224 }
            : { width: '100%', backgroundColor: '#214796' },
          overlayColor: 'transparent',
          sceneStyle: { backgroundColor: '#FAFAFA' },
          headerShown: false,
        }}
        drawerContent={(props) => (
          <CustomDrawerContent {...props} updateSelectedSection={updateSelectedSection} reset={resetDatePagination} />
        )}
        {...rest}>
        <Drawer.Screen key={'home'} name={'home'} component={CustomComponent} />
        <Drawer.Screen key={'editEntity'} name={'editEntity'} component={CustomComponent} initialParams={{ id }} />
        <Drawer.Screen
          key={'editBankingCode'}
          name={'editBankingCode'}
          component={CustomComponent}
          initialParams={{ id }}
        />
        <Drawer.Screen
          key={'merchantDetails'}
          name={'merchantDetails'}
          component={CustomComponent}
          initialParams={{ id }}
        />
        <Drawer.Screen
          key={'processingentitydetails'}
          name={'processingentitydetails'}
          component={CustomComponent}
          initialParams={{ id }}
        />
        <Drawer.Screen key={'ruleDetails'} name={'ruleDetails'} component={CustomComponent} initialParams={{ id }} />
        <Drawer.Screen key={'userDetails'} name={'userDetails'} component={CustomComponent} initialParams={{ id }} />
        <Drawer.Screen key={'addusers'} name={'addusers'} component={CustomComponent} initialParams={{ id }} />
        <Drawer.Screen
          key={'ledgerDetails'}
          name={'ledgerDetails'}
          component={CustomComponent}
          initialParams={{ id }}
        />
        <Drawer.Screen
          key={'holdtransaction'}
          name={'holdtransaction'}
          component={CustomComponent}
          initialParams={{ id }}
        />
        <Drawer.Screen key={'entityManagement'} name={'entityManagement'} component={CustomComponent} />
        <Drawer.Screen key={'searchEntity'} name={'searchEntity'} component={CustomComponent} />
        <Drawer.Screen key={'fiuDetails'} name={'fiuDetails'} component={CustomComponent} />
        {getMenuItems().map((items: any) => {
          return items.data.map((compDetail: any, index: number) => (
            <Drawer.Screen key={`${compDetail.name}_${index}`} name={compDetail.name} component={CustomComponent} />
          ))
        })}
      </Drawer.Navigator>
    </Box>
  )
}

export default DrawerScreen
